// @flow
const SET_ACTIVE_FLYER_ID = 'SET_ACTIVE_FLYER_ID'
const OPEN_MODAL = 'OPEN_MODAL'
const CLOSE_MODAL = 'CLOSE_MODAL'

export type ModalTypes =
  | 'emailFlyerOwner'
  | 'callFlyerOwner'
  | 'share'
  | 'email'

// Action Types
type SetActiveFlyerIdAction = {
  type: 'SET_ACTIVE_FLYER_ID',
  flyerId: ?string
}

type OpenModalAction = {
  type: 'OPEN_MODAL',
  modalType: ModalTypes
}

type CloseModalAction = {
  type: 'CLOSE_MODAL'
}

type FlyerDetailAction =
  | SetActiveFlyerIdAction
  | OpenModalAction
  | CloseModalAction

// Actions and Action Creators
export const setActiveFlyerId = (flyerId: ?string): SetActiveFlyerIdAction => ({
  type: SET_ACTIVE_FLYER_ID,
  flyerId
})

export const openModal = (modalType: ?ModalTypes): OpenModalAction => ({
  type: OPEN_MODAL,
  modalType
})

export const closeModal = (): CloseModalAction => ({
  type: CLOSE_MODAL
})

type InitialFlyerDetailState = {|
  activeFlyerId: ?string,
  modalType: ?ModalTypes
|}

const initialState = {
  activeFlyerId: null,
  modalType: null
}

export const reducer = (
  state: InitialFlyerDetailState = initialState,
  action: FlyerDetailAction
) => {
  switch (action.type) {
    case SET_ACTIVE_FLYER_ID:
      return {
        ...state,
        activeFlyerId: action.flyerId
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalType: action.modalType
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalType: null
      }
    default:
      // (action: empty)
      return state
  }
}



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/redux.js